<template>
    <div>
        <PageBanner :pageTitle="$t('sidebar_inonlays_title_three')" />

        <InOnLaysLongevity/>
    </div>
</template>

<script>
import InOnLaysLongevity from '../blog-details/InOnLaysLongevity.vue'
import PageBanner from '../Common/PageBanner'

export default {
    components: {
       PageBanner,
        InOnLaysLongevity
    }
}
</script>